/**
 * A simple styled button which is blue with no border
 * @param {string} text a string to label button/link
 * @param {*} onClick click handler for button
 * @param {string} paddingXClass padding class for x axis
 * @param {boolean} disabled whether button is disabled
 * @param {boolean} showArrow whether to show a right arrow icon
 * @returns jsx of a button or anchor tag
 */

import React from "react";

import { ReactComponent as ArrowRight } from "@/components/common/icons/arrow-right.svg";
import LoadingSpinner from "@/components/common/loadingSpinner";
import { cn } from "@/utils/cn";

/** @deprecated Use `CTA` from `@/components/ui`. Tracked in EVY-437. */
const BlueRectangularButton = ({
  text,
  onClick,
  paddingXClass = "sm:px-10",
  paddingYClass = "py-5",
  disabled = false,
  type = "button",
  loading = false,
  fullWidth = false,
  children = null,
  showArrow = false,
}: {
  text: string;
  onClick?: () => void;
  paddingXClass?: string;
  paddingYClass?: string;
  disabled?: boolean;
  type?: "button" | "submit";
  loading?: boolean;
  fullWidth?: boolean;
  children?: React.ReactNode;
  showArrow?: boolean;
}) => {
  return (
    <button
      type={type}
      onClick={loading ? () => {} : onClick}
      disabled={disabled}
      className={cn(
        `t4 font-semibold tracking-wider rounded-sm w-full mx-auto ${paddingYClass} ${paddingXClass} bg-evvy-blue text-evvy-black relative`,
        {
          "sm:w-auto": !fullWidth,
          "opacity-50 cursor-not-allowed": disabled || loading,
          "flex items-center justify-center gap-2": showArrow,
        }
      )}
    >
      {children ? (
        <>
          <div className={loading ? "invisible" : ""}>{children}</div>
          {showArrow && <ArrowRight className="w-4 h-4 flex-shrink-0" />}
        </>
      ) : (
        <>
          <div className={loading ? "invisible" : ""}>{text}</div>
          {showArrow && <ArrowRight className="w-4 h-4 flex-shrink-0" />}
        </>
      )}
      {loading && <LoadingSpinner className="text-black absolute inset-0" />}
    </button>
  );
};

export default BlueRectangularButton;
